import {
  ActivityWidget,
  CashToChequeWidget,
  ChequeStatsWidget,
  IncomeSpendChartWidget,
  TotalSumWidget
} from "../components/widgets";
import { Widget } from "../types/widget";

export const WIDGETS: Widget[] = [
  {
    Component: ActivityWidget,
    minWidth: 150,
    name: "رویداد ها",
    oneMan: true,
  },
  {
    Component: IncomeSpendChartWidget,
    minWidth: 400,
    name: "مخارج و درآمد",
    oneMan: true,
  },
  {
    Component: ChequeStatsWidget,
    minWidth: 400,
    name: "آمار چک ها",
    prefFlex: 3,
  },
  {
    Component: TotalSumWidget,
    minWidth: 200,
    name: "جمع کل",
    prefFlex: 2,
  },
  {
    Component: CashToChequeWidget,
    minWidth: 500,
    name: "نسبت دریافت نقدی به چک",
    prefFlex: 4,
  },
];
